import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AUTHENTICATED_HTTP_CLIENT } from '../../../constants';
import { CommentCreationModel, CommentModel } from '../../../models';
import { Observable } from 'rxjs';

@Injectable()
export class CommentApiService {
  private static resourceName = 'comments';

  constructor(@Inject(AUTHENTICATED_HTTP_CLIENT) private httpClient: HttpClient) {}

  getAllComments(): Observable<CommentModel[]> {
    return this.httpClient.get<CommentModel[]>(CommentApiService.resourceName);
  }

  getSpecificComment(commentId: string): Observable<CommentModel> {
    return this.httpClient.get<CommentModel>(`${CommentApiService.resourceName}/${commentId}`);
  }

  createComment(comment: CommentCreationModel): Observable<CommentModel> {
    return this.httpClient.post<CommentModel>(CommentApiService.resourceName, comment);
  }

  updateComment(comment: CommentModel): Observable<unknown> {
    return this.httpClient.put(`${CommentApiService.resourceName}/${comment.id}`, comment);
  }

  deleteComment(commentId: string): Observable<unknown> {
    return this.httpClient.delete<CommentModel>(`${CommentApiService.resourceName}/${commentId}`);
  }
}
